import React from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ReportsList from '../components/ReportsList';
import ReportView from '../components/ReportView';

const ReportsPage = () => {
    const params = useParams();
    let reportId = params.pagename;

    return (<>
        <div className="center-content">
            <div
                style={{ height: "100%" }}
            >
                {(!reportId) &&
                    <ReportsList />
                }
                {(reportId) &&
                    <ReportView
                        reportId={reportId}
                    />
                }
            </div>
        </div>
    </>
    );
}
export default observer(ReportsPage);
